export default __webpack_public_path__ + "static/media/vulture_peak_small.cc7cb7b0.png";